import ClientCard from './ClientCard';
import thekayonkepitu from '../img/c1-thekayonkepitu.jpg';
import toyadevasya from '../img/c2-toyadevasya.jpg';
import bebektepisawah from '../img/c3-bebektepisawah.jpg';
import kajanegroups from '../img/c4-kajanegroups.jpg';
import ubudtropical from '../img/c5-ubudtropical.jpg';
import vilaagungkhalia from '../img/c6-vilaagungkhalia.jpg';
import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const ClientSection = () => {
  const clients = [
    {
      client: 'The Kayon',
      location: 'Ubud',
      imgSrc: thekayonkepitu,
    },
    {
      client: 'Toya Devasya',
      location: 'Kintamani',
      imgSrc: toyadevasya,
    },
    {
      client: 'Vila Bebek Tepi Sawah',
      location: 'Ubud',
      imgSrc: bebektepisawah,
    },
    {
      client: 'Kajane Group',
      location: 'Tegallalang',
      imgSrc: kajanegroups,
    },
    {
      client: 'Villa Agung Khalia',
      location: 'Ubud',
      imgSrc: vilaagungkhalia,
    },
    {
      client: 'Ubud Tropical',
      location: 'Ubud',
      imgSrc: ubudtropical,
    },
  ];

  return (
    <div>
      <div className="font-roboto text-4xl text-green-600 text-center mb-5 mt-20">
        Our Clients
      </div>
      <p className="max-w-3xl mx-auto text-center text-gray-700  text-lg leading-relaxed">
        Serving both private and public villas, we offer premium swimming pool
        supplies and expert maintenance to keep your pool sparkling and
        stress-free all year round. From elegant resorts to personal havens,
        trust us to handle everything from water quality to system upkeep so you
        can relax and enjoy your pool without worry.
      </p>
      <section
        id="client"
        className="bg-white flex flex-wrap justify-center p-2"
      >
        <div className="grid gap-5 grid-cols-1 md:grid-cols-3 md:gap-5 lg:gap-14 xl:grid-cols-3">
          {clients.map((clientData, index) => (
            <ClientCard
              key={index}
              client={clientData.client}
              location={clientData.location}
              imgSrc={clientData.imgSrc}
              data-aos="fade-left"
              data-aos-duration={`${(index + 1) * 500}`}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default ClientSection;
